function iosCopyToClipboard(data: string) {
  let id = 'copyInput';
  let copyInput = document.createElement('input');
  copyInput.setAttribute('type', 'text');
  copyInput.setAttribute('value', data);
  copyInput.id = id;
  document.body.appendChild(copyInput);
  const el = document.getElementById(id) as HTMLInputElement;
  if (el !== undefined && el !== null) {
    var oldContentEditable = el.contentEditable,
      oldReadOnly = el.readOnly,
      range = document.createRange();
    el.readOnly = false;
    range.selectNodeContents(el);

    var s = window.getSelection();
    s?.removeAllRanges();
    s?.addRange(range);

    el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

    el.contentEditable = oldContentEditable;
    el.readOnly = oldReadOnly;

    document.execCommand('copy');
    document.body.removeChild(copyInput);
  }
}
export function copyToClipboard(
  data: string,
  message?: string,
  delay: number = 1000
) {
  let listener = (e: any) => {
    e.clipboardData.setData('text/html', data);
    e.clipboardData.setData('text/plain', data);
    e.preventDefault();
  };

  /* let code = document.createElement('textarea');
    code.innerHTML = this.props.item.code;
    document.body.appendChild(code);
    code.select();*/
  document.addEventListener('copy', listener);
  document.execCommand('copy');
  document.removeEventListener('copy', listener);
  //document.body.removeChild(code);
  // alert(message || "");

  // IOS specific
  iosCopyToClipboard(data);

  // Message user using modal
  let modal = document.createElement('div');
  modal.classList.add('modal');
  modal.setAttribute('id', 'modal');
  let modalMsg = document.createElement('div');
  modalMsg.innerHTML = message || '';
  modal.appendChild(modalMsg);
  modal.onclick = () => {
    modal.classList.remove('modal-visible');
  };
  document.body.appendChild(modal);
  if (document.getElementById('modal')) {
    setTimeout(() => {
      modal.classList.add('modal-visible');
    }, 100);
    setTimeout(() => {
      modal.classList.remove('modal-visible');
    }, delay);
    setTimeout(() => {
      document.body.removeChild(modal);
    }, delay + 2000);
  }
}

export const cmyk2rgb = function (
  c: number,
  m: number,
  y: number,
  k: number,
  normalized: boolean
) {
  c = c / 100;
  m = m / 100;
  y = y / 100;
  k = k / 100;

  c = c * (1 - k) + k;
  m = m * (1 - k) + k;
  y = y * (1 - k) + k;

  var r = 1 - c;
  var g = 1 - m;
  var b = 1 - y;

  if (!normalized) {
    r = Math.round(255 * r);
    g = Math.round(255 * g);
    b = Math.round(255 * b);
  }

  return {
    r: r,
    g: g,
    b: b,
  };
};
